/* eslint-disable no-else-return */
import {
  convertToSafariCompatibleDate,
  getDateFormat,
  keyDataReducer,
  donwloadPDFwithByteCode
} from 'AccountsUtils/common'
import { appendMobileViewURL } from 'AccountsUtils/transform'
import { httpAxios } from 'AccountsUtils/nav-http-cookie'
import { isAndroidApp, isIosApp, urlEndsWith } from 'AccountsUtils/validator'
import {
  GET_CALL,
  NEW_FETCH_TRIP_STATUS,
  BFF_NEW_FETCH_TRIP_STATUS,
  REFUND_STATUS,
  BFF_REFUND_STATUS,
  DOWNLOAD_ETICKET,
  BFF_DOWNLOAD_ETICKET,
  DOWNLOAD_GST_INVOICE,
  BFF_DOWNLOAD_GST_INVOICE
} from 'AccountsConstants/api_endpoints'

import { getQueryParams, isInFlyinDomain } from 'AccountsUtils'

const verticalKeyMap = {
  air: { key: 'flightDetails' },
  hotel: { key: 'hotelDetails' },
  trains: { key: 'trainDetails' }
}
/*
  returns true if trip details page
*/
export const isTripDetailsPage = () => {
  let returnVal
  if (isIosApp() || isAndroidApp()) {
    returnVal = true
  } else if (urlEndsWith('accounts') || urlEndsWith('trips')) {
    returnVal = false
  } else {
    returnVal = true
  }
  return returnVal
}
export const getBaggagePerSegment = baggageStr => {
  // eslint-disable-next-line max-len
  let baggageArr = []
  if (baggageStr) {
    if (typeof baggageStr === 'string') {
      const baggageJson = JSON.parse(baggageStr.replace(/'/g, '"'))
      baggageArr = baggageJson.BI
    } else {
      baggageArr = baggageStr.BI
    }
  }
  return baggageArr
}

export const generateBaggageKey = (from, to, travelDate, travelTime) => {
  let dateStr = new Date(convertToSafariCompatibleDate(travelDate))
  dateStr = getDateFormat(dateStr, 'yyyy-mm-dd', '-')
  const baggageKey = `${from}_${to}_${dateStr}_${travelTime}`
  return baggageKey
}
export const getVerticalDetails = (tripDetails, vertical) => {
  let returnVal = null
  if (
    tripDetails &&
    vertical &&
    Object.hasOwnProperty.call(verticalKeyMap, vertical)
  ) {
    const { key } = verticalKeyMap[vertical]
    returnVal = tripDetails[key]
  }
  return returnVal
}
export const getCancellationLink = (tripId, params = '', fetchControl) => {
  const accountParam = isInFlyinDomain() && fetchControl === 'LINKED' ? '&account=LINKED' : ''
  if (params && params.src === 'home' && params.isMobileApp === 'true') {
    return appendMobileViewURL(
      `/accounts/trips/${tripId}/cancel?src=home&isMobileApp=true${accountParam}`
    )
  }
  const baseUrl = params && params.src === 'home' ?
    `/accounts/trips/${tripId}/cancel?src=home` :
    `/accounts/trips/${tripId}/cancel?src=TDCT`
  return appendMobileViewURL(`${baseUrl}${accountParam}`)
}

export const getOldCancellationLink = (tripId, params) => {
  if (params && params.src === 'home' && params.isMobileApp === 'true') {
    return `/account/trips/${tripId}/cancel?src=home&isMobileApp=true`
  } else if (params && params.src === 'home') {
    return `/account/trips/${tripId}/cancel?src=home`
  } else {
    return `/account/trips/${tripId}/cancel?src=TDCT`
  }
}

export const getAmendmentLink = (newLinkFlag, tripId, params) => {
  let returnLink = `/account/trips/${tripId}/reschedule/prepare?src=TDCT`
  if (newLinkFlag) {
    if (params && params.src === 'home' && params.isMobileApp === 'true') {
      returnLink = `/amendments/select-dates/${tripId}?src=home&isMobileApp=true`
    } else if (params && params.src === 'home') {
      returnLink = `/amendments/select-dates/${tripId}?src=home`
    } else {
      returnLink = `/amendments/select-dates/${tripId}?src=TDCT`
    }
  }
  returnLink = appendMobileViewURL(returnLink)
  return returnLink
}

const getFetchControl = fetchControl => {
  if (fetchControl) return fetchControl
  const params = getQueryParams()
  return params && params.account === 'LINKED' ? 'LINKED' : 'MAIN'
}

export const fetchTripTracker = (tripId, fetchControl) => {
  const useBff = isInFlyinDomain()
  const trackStatusUrl = useBff ? BFF_NEW_FETCH_TRIP_STATUS : NEW_FETCH_TRIP_STATUS
  const extraHeaders = useBff && getFetchControl(fetchControl) === 'LINKED' ? { 'fetch-control': 'LINKED' } : {}
  const url = `${trackStatusUrl}${tripId}`
  const newPromise = new Promise((resolve, reject) => {
    httpAxios(url, GET_CALL, undefined, true, false, false, extraHeaders)
      .then(res => {
        let response = null
        if (res && res.status === 200) {
          response = res.data
        }
        resolve(response)
      })
      .catch(err => reject(err))
  })
  return newPromise
}
export const itemExtractor = (
  segment,
  keyName = '',
  limit,
  needArray = false
) => {
  const { travellers } = segment || {}
  let count = 0
  let returnExtract =
    travellers && travellers.length > 0 ?
      travellers.reduce((init, item) => {
        let newInit = [...init]
        const data =
            keyName === 'additionalBaggage' && item[keyName] !== null ?
              `${item[keyName].length < 10 ? '+' : ''}${item[keyName]}` :
              item[keyName]
        newInit = data && count < limit ? newInit.concat([data]) : newInit
        count = data ? count + 1 : count
        return newInit
      }, []) :
      null
  if (!needArray && returnExtract) {
    returnExtract =
      count > limit ?
        `${returnExtract.join(', ')} +${count - limit}` :
        returnExtract.join(', ')
  }
  return returnExtract || null
}

export const firstLastSegExtractor = (
  flightsArr,
  extractLastFlight = false
) => {
  let first = null
  let last = null
  if (flightsArr && flightsArr[0]) {
    if (flightsArr[0].segmentDetails) {
      first =
        flightsArr[0].segmentDetails && flightsArr[0].segmentDetails.length > 0 ?
          flightsArr[0].segmentDetails[0] :
          null

      if (
        extractLastFlight &&
        flightsArr.length > 1 &&
        flightsArr[flightsArr.length - 1] &&
        flightsArr[flightsArr.length - 1].segmentDetails
      ) {
        last = flightsArr[flightsArr.length - 1].segmentDetails
      } else if (flightsArr[0].segmentDetails) {
        last = flightsArr[0].segmentDetails
      }

      if (last && last.length > 0) {
        last = last[last.length - 1]
      } else {
        last = null
      }
    }
  }
  return { first, last }
}

export const firstLastSegExtractorDesk = (
  flightsArr,
  extractLastFlight = false
) => {
  let first = null
  let last = null
  if (flightsArr && flightsArr[0]) {
    if (flightsArr[0].segmentDetails) {
      first =
        flightsArr[0].segmentDetails && flightsArr[0].segmentDetails.length > 0 ?
          flightsArr[0].segmentDetails[0] :
          null

      if (
        extractLastFlight &&
        flightsArr.length > 1 &&
        flightsArr[flightsArr.length - 1] &&
        flightsArr[flightsArr.length - 1].segmentDetails
      ) {
        last = flightsArr[flightsArr.length - 1].segmentDetails
      } else if (flightsArr[0].segmentDetails) {
        last = flightsArr[0].segmentDetails
      }

      if (last && last.length > 0) {
        const [firstElement] = last
        last = firstElement
      } else {
        last = null
      }
    }
  }
  return { first, last }
}

export const amendSegmentMerger = flights => {
  if (!Array.isArray(flights) || flights.length === 0) {
    return []
  }
  const newMap = new Map()
  flights.forEach((item, idx) => {
    const groupKey =
      item && item.id !== undefined && item.id !== null ? item.id : `fallback_${idx}`
    if (newMap.get(groupKey)) {
      newMap.set(groupKey, [...newMap.get(groupKey), item])
    } else {
      // Start a new bucket with the first segment object.
      newMap.set(groupKey, [item])
    }
  })
  const arr = []
  // eslint-disable-next-line no-unused-vars
  for (const [key, value] of newMap) {
    arr.push(value)
  }
  return arr
}

export const fetchRefundStatus = (tripId = null, dplusxFlag = false, fetchControl) => {
  const useBff = isInFlyinDomain()
  const refundUrl = useBff ? BFF_REFUND_STATUS : REFUND_STATUS
  const extraHeaders = useBff && getFetchControl(fetchControl) === 'LINKED' ? { 'fetch-control': 'LINKED' } : {}
  const url = `${refundUrl}${tripId}${dplusxFlag ? '?fetchHtml=true' : ''}`
  const newPromise = new Promise((resolve, reject) => {
    httpAxios(url, GET_CALL, undefined, true, false, false, extraHeaders)
      .then(res => {
        let response = null
        if (res && res.status === 200) {
          response = res.data
        }
        resolve(response)
      })
      .catch(err => reject(err))
  })
  return newPromise
}
export const extractTripDetails = (data, tripDetails) => {
  let returnDetails = null
  if (data && tripDetails) {
    returnDetails = keyDataReducer(data, tripDetails)
  }
  return returnDetails
}

export const seperatorClassMap = {
  relative: 'mb-6',
  loosely_relative: 'mb-8',
  non_relative: 'mb-10'
}

export const redirectToTripDetail = tripId => {
  const params = getQueryParams()
  if (params && params.src === 'home' && params.isMobileApp === 'true') {
    window.location.href = `/accounts/trips/${tripId}?src=home&isMobileApp=true`
  } else if (params && params.src === 'home') {
    window.location.href = `/accounts/trips/${tripId}?src=home`
  } else {
    window.location.href = `/accounts/trips/${tripId}?src=TDCT`
  }
}

export const callDownlaodEticketAPI = (tripId, fetchControl) => {
  const useBff = isInFlyinDomain()
  const eticketUrl = useBff ? BFF_DOWNLOAD_ETICKET : DOWNLOAD_ETICKET
  const extraHeaders = useBff && getFetchControl(fetchControl) === 'LINKED' ? { 'fetch-control': 'LINKED' } : {}
  httpAxios(`${eticketUrl}/${tripId}`, GET_CALL, undefined, true, false, false, extraHeaders).then(res => {
    if (res && res.status === 200) {
      const byteString = res.data
      const pdfName = `${tripId}-eticket`
      donwloadPDFwithByteCode(byteString, pdfName)
    }
  })
}

export const callDownloadGSTInvoiceAPI = (tripId, fetchControl) => {
  const useBff = isInFlyinDomain()
  const invoiceUrl = useBff ? BFF_DOWNLOAD_GST_INVOICE : DOWNLOAD_GST_INVOICE
  const extraHeaders = useBff && getFetchControl(fetchControl) === 'LINKED' ? { 'fetch-control': 'LINKED' } : {}
  httpAxios(`${invoiceUrl}/${tripId}`, GET_CALL, undefined, true, false, false, extraHeaders).then(res => {
    if (res && res.status === 200) {
      const byteString = res.data
      const pdfName = `${tripId}-invoice`
      donwloadPDFwithByteCode(byteString, pdfName)
    }
  })
}
